import { render } from "./externalInput.vue?vue&type=template&id=2b2b988d"
import script from "./externalInput.vue?vue&type=script&lang=js"
export * from "./externalInput.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__